import * as React from 'react';
import { useSelector } from 'react-redux';
import { PageDescription } from '../../components/PageDescription';
import { PageTitle } from '../../components/PageTitle';
import { selectPageSeo } from '../../selectors/seo';

export const PageTitleAndDescriptionContainer: React.FC = () => {
  const { h1, description } = useSelector(selectPageSeo);

  return (
    <>
      <PageTitle>{h1}</PageTitle>
      {description && <PageDescription>{description}</PageDescription>}
    </>
  );
};
